import React, { useState, useEffect, useRef, useContext } from "react";
import {
  Table,
  ScrollArea,
  rem,
  Text,
  UnstyledButton,
  Center,
  Select,
  Pagination,
  Checkbox,
  Tabs,
  Badge,
  Group,
  Button,
  Paper,
  Skeleton,
  Grid,
  TextInput,
  Textarea,
  Breadcrumbs,
  Anchor,
  Stack,
  Image,
  NumberInput,
} from "@mantine/core";
import {
  IconSearch,
  IconSelector,
  IconChevronDown,
  IconChevronUp,
  IconTrash,
  IconChecklist,
  IconUserPlus,
  IconEye,
  IconTruck,
  IconPercentage,
} from "@tabler/icons-react";
import classes from "./GamesFPS.module.css";
// import DeleteStaff from "./DeleteStaff";
// import { RowDataDealerRebate } from "./types";
import { props } from "./props";
import { CustomTable } from "../Table/CustomTable";
// import { dealer } from "../types/RowDataTypes";
import { dealerRebate } from "../types/RowDataTypes";
import { useFetchRowData } from "../hooks/useFetchRowData";
import { SearchBar } from "../SearchBar/SearchBar";
import useAxiosPrivate from "../../auth/useAxiosPrivate";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useQuery, useMutation } from "react-query";
import {
  showErrorAlert,
  showEditWarning,
  showSuccessAlert,
} from "../../helper/alerts";
import Header from "../static/Header";
// import VerifyDealer from "./VerifyDealer";
// import getOrderTable from "../../DataDisplay/DataDisplayTable/OrderTable";
// import getDealerTable from "../../DataDisplay/DataDisplayTable/DealerTable";
import getDealerRebateTable from "../../DataDisplay/DataDisplayTable/DealerRebateTable";
// import CreateRebateModal from "./CreateRebateModal";
// import DeleteModal from "./DeleteModal";

import { formatYYYY_MM_DD } from "../../helper/DateTime";


export function ManageFPS() {
  const axiosPrivate = useAxiosPrivate();
  let { id } = useParams();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [gamesFPS, setGamesFPS] = useState<any[]>([])


    const getGPUDetailsQuery = useQuery(
        "getGPUDetails",
        async ({ signal }) => (await axiosPrivate.post("/api/admin/gpu/read-by-id", { id } ,{ signal })).data.data,
        {
            initialData: {
                gpu: null,
                games: [],
            },
            cacheTime: 0,
            onSuccess: (res) => {
                // console.log(res)
                setGamesFPS(res.games ? res.games : [])
            },
            onError: () => {

            }
        }
    );

    const updateFPSMutation = useMutation(
        (data: any) => axiosPrivate.post("/api/admin/fps/update-multiple", data, {headers: {'Content-Type': 'multipart/form-data'}}),
        {
            onSuccess: (res: any) => {
                showSuccessAlert("FPS Successfully Updated");
            },
            onError:(err: any) => {
                let errMsg = err?.response?.data?.message
                showErrorAlert(errMsg ? errMsg : 'An error has occured');
            }
        }
    );

    const updateItemValue = (index: number, value: number|string, type: string) => {
        var updatedArr = []
        var tempArr : any = gamesFPS
        if(type === 'fhd'){
            updatedArr = tempArr.map((item: any, i: number) =>
                i === index ? { ...item, fhd: value } : item
            );
        }
        else if(type === 'qhd'){
            updatedArr = tempArr.map((item: any, i: number) =>
                i === index ? { ...item, qhd: value } : item
            );
        }
        else if(type === 'uhd'){
            updatedArr = tempArr.map((item: any, i: number) =>
                i === index ? { ...item, uhd: value } : item
            );
        }
        
        setGamesFPS(updatedArr)
    };

    const onPressUpdate = () => {
        // let 
        updateFPSMutation.mutate({fpsArr: JSON.stringify(gamesFPS)})
    }

  return (
    <div className={classes.orderContainer}>
      <ScrollArea className={classes.parentContainer}>
        <Header
          title={
            <div>
              <p>Manage FPS {getGPUDetailsQuery?.data?.gpu?.model ? `- ${getGPUDetailsQuery?.data?.gpu?.model}` : null}</p>
            </div>
          }
        />
        <Breadcrumbs mx={20} my={'sm'}>
            <Anchor component={Link} to={'/games-fps'}>
                Games FPS
            </Anchor>
            <Anchor>
                Manage FPS
            </Anchor>
        </Breadcrumbs>
        <Paper mx={20} my={'sm'}>
            <Skeleton visible={getGPUDetailsQuery.isFetching || getGPUDetailsQuery.isError} animate={!getGPUDetailsQuery.isError}>
                <Paper style={{backgroundColor: '#F8F9FA'}} p={'sm'}>
                <Grid>
                    <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
                        <Text fw={700}>Games FPS</Text>
                        <Stack >
                            {gamesFPS.map((item: any, index: number)=>(
                                <div key={index} style={{backgroundColor: '#e9ecef', padding: '0px 0px', border: '1px solid #ced4da', display: 'flex', alignItems: 'center', gap: 20}}>
                                    <Image
                                        src={item?.img}
                                        w={130}
                                        h={130}
                                    />
                                    <div style={{display: 'flex', flexDirection: 'column'}}>
                                        <Text fw={700}>{item?.name}</Text>
                                        <Group>
                                        <NumberInput
                                            label="FHD FPS"
                                            description="1080p"
                                            allowDecimal={false}
                                            allowNegative={false}
                                            value={item?.fhd}
                                            // onChange={(event) => setGamesFPS((prev)=>[...prev, prev[index].fps])}
                                            onChange={(e) => updateItemValue(index,e,'fhd')}
                                        />
                                        <NumberInput
                                            label="QHD FPS"
                                            description="1440p"
                                            allowDecimal={false}
                                            allowNegative={false}
                                            value={item?.qhd}
                                            // onChange={(event) => setGamesFPS((prev)=>[...prev, prev[index].fps])}
                                            onChange={(e) => updateItemValue(index,e,'qhd')}
                                        />
                                        <NumberInput
                                            label="UHD FPS"
                                            description="2160p"
                                            allowDecimal={false}
                                            allowNegative={false}
                                            value={item?.uhd}
                                            // onChange={(event) => setGamesFPS((prev)=>[...prev, prev[index].fps])}
                                            onChange={(e) => updateItemValue(index,e,'uhd')}
                                        />
                                        </Group>
                                    </div>
                                </div>
                            ))
                            }
                            <Group justify="flex-end">
                                <Button onClick={onPressUpdate} loading={updateFPSMutation.isLoading} disabled={getGPUDetailsQuery.isError || gamesFPS.length === 0}>Update Games FPS</Button>
                            </Group>
                        </Stack>
                    </Grid.Col>
                </Grid>
                </Paper>
            </Skeleton>
        </Paper>

          {/* <ScrollArea
            w={
              window.innerWidth -
              document.getElementById("nav-bar")!!.getBoundingClientRect().width
            }
          >
              

          </ScrollArea> */}



        {/* {isEditMode && (
          <VerifyDealer
            isOpen={isEditMode}
            onClose={() => setEditMode(false)}
            onSaveChanges={(editedData, action, remark) =>
                handleVerifyDealer(editedData, selectedRow, action, remark)
            }
            initialData={selectedRow as RowDataDealer}
          />
        )} */}
      </ScrollArea>
    </div>
  );
}

export default ManageFPS;
